import React from "react";
import imgUrl from "../assets/images/imgUrl";
import Typography from "@mui/material/Typography";

function ThoughtLeadership() {
  return (
    <div className="homeMainWrapper biographyWrapper awardsWrapper thoughtLeadershipwrapper bgPosition mainContent">
      <div className="homeBackground">
        <div className="upperImage">
          <img src={imgUrl.smileLogo} alt="smile logo"></img>
        </div>
      </div>

      {/* thought leadership section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.leadership} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles lifeStorytitle">
            Thought Leadership
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            Beyond his on-ground work, <b> Dr. Huzaifa Khorakiwala </b> is a prolific thought
            leader who shares ideas and insights to inspire change. His perspectives
            on peace, healthcare and social responsibility have been sought after in
            publications, conferences and media around the world. This section collates his intellectual contributions – from articles and interviews to
            keynote speeches and multimedia resources – offering a deep dive into his
            philosophy and message.

          </Typography>
        </div>
      </section>

      {/* publication and article section */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.publication} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Publications & Articles
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            <b> Dr. Khorakiwala  </b>has authored and contributed to numerous articles, opeds and papers that reflect his visionary thinking. He is a regular
            contributor to discussions on public health, corporate social responsibility
            (CSR) and peace-building in leading journals and news media. He has
            penned thought-provoking op-eds in outlets like <b className='font-italic '> The Hindu Business Line </b>
            and <b className='font-italic '> National Herald </b>, where he analysed challenges such as international
            trade impacts on Pharma and the lessons of the COVID-19 pandemic for
            our healthcare system.In <b> April 2025 </b>, his commentary on US-imposed tariffs highlighted potential
            threats to India’s pharmaceutical industry and called for strategic
            preparedness. In the same vein, he has advocated for greater innovation in
            antibiotics and celebrated his company’s breakthroughs that could save
            millions of lives
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px">
            On the CSR front, <b> Dr. Khorakiwala </b> is a recognised voice. He co-authored
            the book Essentials in Corporate Social Responsibility, a comprehensive
            guide on CSR best practices, which garnered an industry award for its
            contribution. Through this work and others, he encourages businesses to
            integrate social good into their core strategy, emphasising that profitability
            and societal benefit can go hand in hand.
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px">
            He also frequently shares his musings on professional networking
            platforms. His articles (published on his profile) cover a range of
            inspirational themes – from leadership lessons to the importance of values.
            Notable among these is an essay titled Be Calm, & Strong in Difficulties
            (<b>2019</b>), in which he wrote about resilience in the face of personal and
            professional challenges. In a lighter vein, he authored I WILL FOOL YOU
            TODAY (an April Fools’ Day 2019 reflection on honesty and humility).
            These writings exhibit his eloquent, down-to-earth style that resonates with
            a broad audience of followers.
          </Typography>

          <div className="subsectionFindsection mt-50px">
            <Typography className="whiteColortext">
              In this subsection, you will find:
            </Typography>
          </div>

          {/* articles and op-eds */}

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.article} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Articles & Op-Eds
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            A library of written pieces by <b> Dr. Khorakiwala </b> (Healthcare, Peace &
            Values, CSR, Leadership). Each entry provides a summary and a link to
            read the full text. Whether it’s an editorial in a business newspaper or a
            column in a humanitarian magazine, these articles encapsulate his
            viewpoints and proposals for a better world.
          </Typography>
        </div>
      </section>

      {/* interviews and media appearances section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.interview} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles ">
            Interviews & Media Appearances
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            <b>Dr. Khorakiwala’s </b> expertise and story have made him a sought-after figure
            in media. This section features a curated collection of interviews, panel
            discussions and press appearances that offer insights in his own voice.

          </Typography>
        </div>
      </section>

      {/* television and radio interviews */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.television} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Television and Radio <br />
            Interviews
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            Watch and listen to <b> Dr. Khorakiwala </b> on international news networks and
            radio shows. For example, his interview on Talk 100.3 FM Dubai (2025)
            where he passionately explained the vision behind the <b className='font-italic '> Global Justice,
            Love & Peace Summit </b> or his appearance on ET Now where he discussed
            the <b className='font-italic '> I Am Peacekeeper Movement’s </b> grassroots impact. These clips
            showcase his ability to communicate complex ideas in an accessible,
            heartfelt manner.
          </Typography>
        </div>
      </section>

      {/* panel and discussions section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.panel} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles">
            Policy & Advocacy / Discussion
          </Typography>

          <div className="gallery-box videoSection whiteBorder">
            <iframe
              width="560"
              height="315"
              loading="lazy"
              src="https://www.youtube.com/embed/Qclv0Bx7odk?si=UmNWJGgQ5IYEGIhR"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            <b> Dr. Khorakiwala </b> has joined global forums – from <b className='font-italic '> World Economic Forum </b>
            panels to NGO roundtables. One notable discussion is the Sustainomics &
            Peace webinar (featured on our YouTube channel) where he engaged with
           <b> Nobel Laureate Prof. Mohan Munasinghe </b>  on linking sustainable
            development with peace efforts. In such dialogues, he often serves as a
            bridge between sectors, advocating collaborative approaches to global
            issues.
          </Typography>
        </div>
      </section>

      {/* print and digital media section */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.print} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Print & Digital Media <br />
            Interviews
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            Read Q&A style interviews published in magazines and online platforms.
            In these interviews, <b> Dr. Khorakiwala </b> often shares personal anecdotes – for example, how a childhood lesson from his father shaped his ethos or his
            experience of walking through a refugee camp that reinforced his
            commitment to peace. Media profiles (such as in <b className='font-italic '> Mumbai Mirror </b>) have
            also delved into his personality, portraying the man behind the mission – a
            leader who is at once humble, humorous and unflinchingly idealistic.
          </Typography>
        </div>
      </section>

      {/* talks and podcasts section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.podcast} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles">
            Talks & Podcasts
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            In the age of digital media, <b> Dr. Khorakiwala </b> has also been featured on
            podcasts and recorded talks. This includes motivational talks for youth
            forums, discussions on entrepreneurship with a conscience and interviews
            on philanthropy-focused podcasts. Visitors can play these audio segments
            directly or download them for later listening.
            listening.
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo mt-20px">
            Each media entry is accompanied by a brief description and date, as well
            as external links or embedded video players when available. Through
            these, you can hear <b> Dr. Khorakiwala's </b> philosophy articulated in his own
            words – a treat for those looking for inspiration or a deeper understanding
            of his initiatives.
          </Typography>
        </div>
      </section>

      {/* keynote and speeches archive section */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.keynote} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            KEYNOTES & SPEECHES <br /> ARCHIVE
          </Typography>

          <div className="gallery-box videoSection">
            <iframe
              width="560"
              height="315"
              loading="lazy"
              src="https://www.youtube.com/embed/oj2J-jciWgM?si=XYzThQJ09Cww8_H8"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
           A powerful public speaker, <b> Dr. Khorakiwala </b> has delivered keynote
          speeches at major events around the globe. In this archive, we provide
          access to his most impactful addresses:
          </Typography>
        </div>
      </section>

      {/* global justice section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.globalJusticeLogo} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles globalTitle">
            GLOBAL JUSTICE,<br /> LOVE & PEACE SUMMIT
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            Where he welcomed delegates with a rousing call: <span className='font-italic'>  One voice, one planet
            – let us together script a new chapter of justice and peace. </span> He recounts the
            journey of the Peace Charter and invokes the wisdom of <b> Mahatma Gandhi </b>
            and <b> Nelson Mandela </b> to remind the world that love is stronger than hate.
          </Typography>
        </div>
      </section>

      {/* Wockhardt section */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper wockhardtSection p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg sectionWiselogo">
            <img src={imgUrl.wockhardtLogo} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
           WOCKHARDT FOUNDATION: KEYNOTE ON PURPOSEFUL
          LEADERSHIP, HEALTH AND SUSTAINABILITY AT THE 5TH GOOD AIR
          SUMMIT
          </Typography>

          <div className="gallery-box videoSection">
            <iframe
              width="560"
              height="315"
              loading="lazy"
              src="https://www.youtube.com/embed/AdDHerbXbxY?si=D49aFF52J4C9AkDs"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
           In this speech, <b> Dr. Khorakiwala </b> speaks to volunteers and partners of the
          Foundation. He shares stories of beneficiaries, connecting them to the
          broader vision of a healthier, happier <span className='font-italic'>India. </span> His words, <span className='font-italic'>Healthcare is not a
          privilege but a human right, </span> resonate as he outlines the <span className='font-italic'>Foundation’s goals </span>
          for the next decade.
          </Typography>
        </div>
      </section>

      {/* university convocation section */}

      <section>
        <div className="dynamicBannerwrapper lifeStoryWrapper  peacekeeperWrapper p-40px d-flex-align-center-justify-center flex-direction-column ">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground">
            <img src={imgUrl.convocation} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading blackTitles globalTitle">
           UNIVERSITY CONVOCATIONS AND COMMENCEMENTS
          </Typography>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            <b> Dr. Khorakiwala </b> has been invited as a commencement speaker at multiple
            universities where he’s received honorary doctorates. For example, his 
            <b> 2017 </b> convocation speech at an international university in <span className='font-italic'> London </span>  (upon
            receiving an <span className='font-italic'> Honorary Doctorate in Social Services </span> ) is preserved here. In it,
            he encouraged graduates to embrace empathy, saying <span className='font-italic'>Measure success not
            only by your wealth or titles, but by the lives you touch. </span>
          </Typography>
        </div>
      </section>

      {/* corpoeate leadership forums section */}

      <section>
        <div className="whiteSection lifeStoryWrapper publicationWrapper p-40px d-flex-align-center-justify-center flex-direction-column bgMidgradient">
          <div className="coloredBoxes">
            <div className="blueBox"></div>
            <div className="purpleBox"></div>
            <div className="blackBox"></div>
            <div className="greyBox"></div>
            <div className="pinkBox"></div>
          </div>

          <div className="iconBackground iconYellowbg">
            <img src={imgUrl.corporate} alt="icon"></img>
          </div>

          <Typography className="headings sectionHeading">
            Corporate Leadership Deliberations
          </Typography>

          <div className="gallery-box videoSection">
            <iframe
              width="560"
              height="315"
              loading="lazy"
              src="https://www.youtube.com/embed/eMBMd3zMH3o?si=vSWJZwdfefBkl1Ru"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>

          <Typography className="sectionHeading blackTitles detailedPersonalinfo">
            As an industry leader, he also speaks at business conferences about ethical
            leadership. An excerpt from his address at the <b> 2019 India Leadership
            Conclave </b> reveals his stance on corporate compassion: The purpose of
            business, ultimately, is to improve the quality of life. Profit is a means, not
            an end.
          </Typography>
        </div>
      </section>
    </div>
  );
}

export default ThoughtLeadership;
